// extracted by mini-css-extract-plugin
module.exports = {"Container":"NotFound_Container__3kWif","Status":"NotFound_Status__28L1d","Message":"NotFound_Message__2tz68"};